import {func} from 'prop-types';

import {runAfterAnimations} from '../utils/misc.js';
import useLocalStore from '../utils/useLocalStore.js';

export default function ThemeSelect({onClose = () => {}}) {
  const theme = useLocalStore(st => st.theme);
  const setTheme = useLocalStore(st => st.setTheme);
  const themes = useLocalStore(st => st.themes);

  return (
    <select
      className="select select-bordered select-ghost select-sm"
      onChange={e => {
        setTheme(e.target.value);
        runAfterAnimations(onClose);
      }}
      value={theme}
    >
      {/* <option value="system" disabled>
        system
      </option> */}
      {themes.map(theme => (
        <option key={theme} value={theme}>
          {theme}
        </option>
      ))}
    </select>
  );
}

ThemeSelect.propTypes = {
  onClose: func,
};
